// src/icons/PaypalIcon.jsx
import * as React from "react";

export default function PaypalIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      width={24}
      height={24}
      {...props}
    >
      <path
        fill="currentColor"
        d="M111.4 295.8l14.2-91.1h81.5c39.9 0 65.3-20.6 71.6-61.1 6.6-43.2-19.1-65-59.2-65h-91.6l14.2-91.1c1.4-9 9.2-15.5 18.3-15.5h93.2c71.4 0 123.5 53.6 112.1 124.4-11.1 72.4-68.1 123.4-138.9 123.4h-65.4c-9.1 0-16.9-6.5-18.3-15.5zm239.4-17.7c-9.2-6.3-21.3-3.4-27.5 6.1-37.8 59-102.5 94.1-173.2 94.1h-65.4l-15.8 101c-1.4 9 5.6 17.2 14.7 17.2h65.4c122.5 0 224.1-87.9 242.4-208.3 1.6-10.2-3.8-20.4-11.6-26.1z"
      />
    </svg>
  );
}
